import { Component, type ComponentChildren } from "preact";

type ErrorBoundaryProps = {
  children: ComponentChildren;
  fallback?: ComponentChildren;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: { componentStack?: string }) {
    if (process.env.NODE_ENV === "development") {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="festapp-error">
          <p>Something went wrong</p>
        </div>
      );
    }

    return this.props.children;
  }
}
